<template>
  <DeviceSetupSection>
    <template v-slot:left>
      <PageContainer
        :class="$style.container"
      >
        <template v-slot:body>
          <Container>
            <HeadingLarge>
              Let's setup a device in a few quick steps
            </HeadingLarge>
            <div
              :class="$style.list"
            >
              <div
                v-for="step in steps"
                :key="step.header"
                :class="$style.step"
              >
                <img
                  :class="$style.icon"
                  inline
                  :src="step.icon"
                >
                <div>
                  <HeadingMedium :hasMargin="false">
                    {{ step.header }}
                  </HeadingMedium>
                  <ParagraphBody>
                    {{ step.subheader }}
                  </ParagraphBody>
                </div>
              </div>
            </div>
          </Container>
        </template>

        <template v-slot:footer>
          <Container>
            <ButtonGroupSave
              :isFullWidth="false"
              :primaryButtonProps="$options.primaryButtonProps"
              :secondaryButtonProps="$options.secondaryButtonProps"
              @primaryAction="addDevice"
              @secondaryAction="handleCancel"
            />
          </Container>
        </template>
      </PageContainer>
    </template>
    <template v-slot:right>
      <div
        :class="[$style.image, $style.backgroundImage]"
      />
    </template>
  </DeviceSetupSection>
</template>

<script>
import {
  ButtonGroupSave,
  Container,
  HeadingLarge,
  HeadingMedium,
  PageContainer,
  ParagraphBody,
  Types,
} from '@jumpcloud/ui-components';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import DeviceSetupSection from 'client/Discover/components/GuidedSetup/DeviceSetupSection.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';

const { PrimaryButtonProps, SecondaryButtonProps } = Types;

const primaryButtonProps = PrimaryButtonProps({ text: 'Add Device' });
const secondaryButtonProps = SecondaryButtonProps({ hasNoBackground: true });

const {
  description,
  location,
  section,
  text,
} = eventProperties;

export default {
  name: 'DeviceSetupIntro',

  components: {
    ButtonGroupSave,
    Container,
    DeviceSetupSection,
    HeadingLarge,
    HeadingMedium,
    PageContainer,
    ParagraphBody,
  },

  EventHelper,

  primaryButtonProps,
  secondaryButtonProps,

  data() {
    return {
      steps: [
        {
          header: 'Choose a device to setup',
          icon: 'img/growth/choose-device.svg',
          subheader: 'Windows, Mac, Linux',
        },
        {
          header: 'Install the JumpCloud agent',
          icon: 'img/growth/install-agent.svg',
          subheader: 'You can install the agent manually or via command',
        },
        {
          header: 'Bind a user to the device',
          icon: 'img/growth/bind-user.svg',
          subheader: 'You can do this later if you don\'t have users yet',
        },
      ],
    };
  },

  methods: {
    addDevice() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'User proceeded through the guided setup flow',
        [location]: eventLocations.immersiveOnboarding,
        [section]: 'Device Setup Landing',
        [text]: 'Add Device',
      });

      this.$emit('next');
    },

    handleCancel() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'User canceled/closed the guided setup flow',
        [location]: eventLocations.immersiveOnboarding,
        [section]: 'Device Setup Landing',
        [text]: 'Cancel',
      });

      this.$emit('close');
    },
  },
};
</script>

<style scoped module>
@import './css/guided-setup.css';

.backgroundImage {
  background-image: url('/img/growth/device-setup-1.png');
}

.icon {
  height: 4rem;
  width: 4rem;
}

.list {
  padding: var(--jc-spacer-medium);
}

.step {
  align-items: center;
  display: flex;
  gap: var(--jc-spacer-large);
  padding: var(--jc-spacer-large) 0;
}

.step:first-of-type {
  padding-top: 0;
}
</style>
